export interface PanelComponent {
    data: any;
}
